module.exports = __webpack_public_path__ + "img/Group 70@2x.31b71d93.png";